export const cableRegex = new RegExp('^.boxPlan__cableTubeGroup__');

export enum ColorEnum {
    BLACK = '#000000',
    BLUE = '#0070C0',
    BROWN = '#993300',
    GREEN = '#92D050',
    GREY = '#C1C1C1',
    ORANGE = '#FFC000',
    PINK = '#FF65CC',
    PURPLE = '#7638A3',
    RED = '#FF0000',
    TURQUOISE = '#00B0F0',
    WHITE = '#FFFFFF',
    YELLOW = '#FFFF00',
}

export enum FontColorEnum {
    BLACK = '#000000',
    WHITE = '#FFFFFF',
}

export const lightColors = [
    ColorEnum.YELLOW,
    ColorEnum.WHITE,
    ColorEnum.TURQUOISE,
    ColorEnum.GREY,
    ColorEnum.ORANGE,
    ColorEnum.GREEN,
];

export const standardColors: Record<number, ColorEnum> = {
    1: ColorEnum.RED,
    2: ColorEnum.BLUE,
    3: ColorEnum.GREEN,
    4: ColorEnum.YELLOW,
    5: ColorEnum.PURPLE,
    6: ColorEnum.WHITE,
    7: ColorEnum.ORANGE,
    8: ColorEnum.GREY,
    9: ColorEnum.BROWN,
    10: ColorEnum.BLACK,
    11: ColorEnum.TURQUOISE,
    12: ColorEnum.PINK,
};

export const viewIdRegex = new RegExp('^boxPlan_view_');
